import React from 'react'

import { Form, Divider, Button, Col, Row } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as CategoriaCrud from 'services/categoria.service'
import * as TempInventarioCrud from 'services/tempInventario.service'

import ImportarRegistrosModal from './modals/importarRegistros'

import { DownloadAxiosFile } from 'utils'

const CategoriaSection = () => {
  const __zariContext = React.useContext(ZariContext)

  const [checkAll, setCheckAll] = React.useState(false)
  const [categorias, setCategorias] = React.useState([])

  const [mostrarImportarRegistrosModal, setMostrarImportarRegistrosModal] = React.useState(false)

  const reloafRef = React.useRef(1)

  React.useEffect(() => {
    CategoriaCrud.obtenerAsSelect().then(({ data }) => {
      setCategorias(data)
    })
  }, [])

  const checkOptionHandler = ({ _id }) => {
    reloafRef.current = reloafRef.current + 1
    setCheckAll(false)
    setCategorias(prev => {
      return prev.map(x => {
        return {
          ...x,
          checked: x._id === _id ? !x.checked : x.checked
        }
      })
    })
  }

  const seleccionarTodosClick = () => {
    reloafRef.current = reloafRef.current + 1
    setCheckAll(prevChecked => {
      setCategorias(prev => {
        return prev.map(x => ({
          ...x,
          checked: !prevChecked
        }))
      })

      return !prevChecked
    })
  }

  const clickDescargarPlantillaHadler = e => {
    e.preventDefault()
    const selected = categorias.filter(x => x.checked).map(x => x._id)

    TempInventarioCrud.getPlantillaCategorias({ categorias: selected })
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers, 'Plantilla Inventario Fisico - Ingreso Masivo Por Categorias.xlsx')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <>
      <Row className='px-5'>
        <Col md={4}>
          <Row>
            <Col md={12}>
              <Form.Checkbox
                name='checkSeleccionar'
                label='SELECCIONAR TODAS'
                id='checkbox-marca-seleccionarTodas'
                checked={checkAll}
                onChange={seleccionarTodosClick}
              />
            </Col>
          </Row>
          <Divider noMargin />
          <Row>
            <Col md={12}>
              <div>
                {categorias.map(x => (
                  <Form.Checkbox
                    name='checkCate'
                    key={`${x._id}${reloafRef.current}`}
                    label={x.nombre}
                    id={`checkbox-categoria-${x._id}`}
                    checked={x.checked}
                    onChange={e => checkOptionHandler({ _id: x._id })}
                  />
                ))}
              </div>
            </Col>
          </Row>
        </Col>
        <Col md={8} className='text-right'>
          <Button onClick={clickDescargarPlantillaHadler}>Descargar Plantilla</Button>
          <Button className='ml-3' onClick={e => setMostrarImportarRegistrosModal(true)}>
            Importar Registros (CATEGORIA)
          </Button>
        </Col>
      </Row>
      {mostrarImportarRegistrosModal && (
        <ImportarRegistrosModal handleClose={e => setMostrarImportarRegistrosModal(false)} show={mostrarImportarRegistrosModal} tipoRegistro='C' />
      )}
    </>
  )
}

export default CategoriaSection
